import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Link = iotsUtils.fromList(constants.report.type.links);
